import comp from "./CriteriaRubricAssessment";
export default comp;
